import { GlobalAppState } from '@state/store';
import { FooterTypes } from '@model/content';

export const getFooter = (footerType?: FooterTypes) => (state: GlobalAppState) =>
  state.footer[footerType || FooterTypes.MAIN];
